import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
const breeds = [{
  name: 'Perro Salchicha',
  image: 'https://cdn.magicpatterns.com/uploads/tHNVv6oTcMw17BZLFwZC4m/20260225_1912_Image_Generation_simple_compose_01kjbdrg11ewxv6nnar0hhycrv.png'
}, {
  name: 'Golden Retriever',
  image: 'https://cdn.magicpatterns.com/uploads/b9BgAzEgP28dc51cG1G2sA/20260225_1918_Image_Generation_simple_compose_01kjbe3ewcfnxsyah3g5mv1z4c.png'
}, {
  name: 'Bulldog Francés',
  image: 'https://cdn.magicpatterns.com/uploads/55b2iNVqzWDzqX8toVHuot/20260225_1913_Hyper-Realistic_Crochet_Bulldog_simple_compose_01kjbds9qgfcbtgtwstnejfp5f.png'
}, {
  name: 'Labrador',
  image: 'https://cdn.magicpatterns.com/uploads/hwHXWAX3P3qdPFW1hoo3zQ/20260225_1922_Image_Generation_simple_compose_01kjbe9d6ffaj9xrezyw03e6eb.png'
}, {
  name: 'Poodle / Caniche',
  image: 'https://cdn.magicpatterns.com/uploads/shtbGzu9Ajxg9KVdWaJhXQ/20260225_1921_Crochet_Poodle_Amigurumi_simple_compose_01kjbe8cnbfgwadkdw1cchy9ra.png'
}, {
  name: 'Chihuahua',
  color: 'from-orange-100 to-orange-50'
}, {
  name: 'Husky Siberiano',
  color: 'from-slate-200 to-blue-50'
}, {
  name: 'Pastor Alemán',
  color: 'from-amber-200 to-amber-100'
}, {
  name: 'Corgi',
  color: 'from-orange-200 to-orange-100'
}, {
  name: 'Gato Siamés',
  color: 'from-stone-200 to-stone-100'
}, {
  name: 'Gato Persa',
  color: 'from-gray-100 to-white'
}, {
  name: 'Maine Coon',
  color: 'from-stone-300 to-stone-200'
}];
export function BreedGallery() {
  return <section id="galeria" className="py-10 md:py-16 bg-linen" data-id="element-40">
      <div className="max-w-6xl mx-auto px-4" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-42">
          <span className="text-copper font-bold tracking-[0.2em] text-sm uppercase" data-id="element-43">
            ¿Qué encontrarás en este ebook?
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown mt-3 mb-4" data-id="element-44">
            <span className="text-terracotta" data-id="element-45">+60 patrones</span> organizados
            por raza
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto" data-id="element-46">
            Más de 60 razas de perros y gatos con patrones detallados. Cada uno
            diseñado para capturar los rasgos únicos de tu mascota. Aquí algunas
            de las razas incluidas:
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5" data-id="element-47">
          {breeds.map((breed, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.04
        }} className="group cursor-pointer" data-id="element-48">
              <div className="etsy-card etsy-card-hover overflow-hidden" data-id="element-49">
                {'image' in breed && breed.image ? <div className="aspect-square overflow-hidden relative" data-id="element-50">
                    <img src={breed.image} alt={`Amigurumi ${breed.name}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-51" />
                    <div className="absolute top-3 right-3 bg-white/90 p-1.5 rounded-full shadow-sm opacity-0 group-hover:opacity-100 transition-all duration-300" data-id="element-52">
                      <Heart size={14} className="text-terracotta fill-terracotta" data-id="element-53" />
                    </div>
                  </div> : <div className={`aspect-square bg-gradient-to-br ${'color' in breed ? breed.color : 'from-gray-100 to-gray-50'} flex items-center justify-center relative`} data-id="element-54">
                    <span className="text-deep-brown/10 font-heading text-5xl font-bold select-none" data-id="element-55">
                      {breed.name.charAt(0)}
                    </span>
                    <div className="absolute top-3 right-3 bg-white/90 p-1.5 rounded-full shadow-sm opacity-0 group-hover:opacity-100 transition-all duration-300" data-id="element-56">
                      <Heart size={14} className="text-terracotta fill-terracotta" data-id="element-57" />
                    </div>
                  </div>}
                <div className="p-3 text-center" data-id="element-58">
                  <h3 className="font-bold text-deep-brown text-sm group-hover:text-copper transition-colors" data-id="element-59">
                    {breed.name}
                  </h3>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-10 text-center" data-id="element-60">
          <p className="text-copper font-bold text-sm mb-1" data-id="element-61">Y muchas más...</p>
          <p className="text-sm text-gray-400 italic" data-id="element-62">
            * Todos los patrones incluyen instrucciones para adaptar colores y
            manchas a tu mascota.
          </p>
        </motion.div>
      </div>
    </section>;
}